import { Component } from 'san';
import * as _ from 'lodash';

import { IHelpFile, IUploaderErrorResponse } from 'src/models';

import toasterService from 'src/services/toaster.service';
import uploaderService from 'src/services/uploader.service';
import userService from 'src/services/user.service';
import helpService from 'src/services/help.service';

export default class File extends Component {
    constructor(options: any) {
        super(options);
    }

    static components = {};

    initData(): {
        editEnable: boolean;
        files: IHelpFile[];
    } {
        return {
            editEnable: undefined,
            files: [],
        };
    }

    inited() {
        this.getFiles();
        this.getEditEnable();
    }

    attached() {
        this.initUploader();
    }

    getFiles() {
        const oldFiles = this.data.get('files');
        helpService.getDocumentFiles().then((files) => {
            this.data.splice('files', [0, oldFiles.length, ...files]);
        });
    }

    getEditEnable() {
        userService.getCurrentUserIsSystemAdmin().then((isSystemAdmin) => {
            this.data.set('editEnable', isSystemAdmin);
        });
    }

    // 初始化文件上传
    initUploader() {
        uploaderService.show({
            isMultiple: true,
            selector: '#fileUploader',
            server: '/api/files/upload',
            errorCallback: (response: IUploaderErrorResponse) => {
                toasterService.show({
                    type: 'danger',
                    title: response.message,
                    contents: response.errors,
                });
            },
            finishedCallback: (files) => {
                if (!files.length) {
                    return;
                }
                files = _.map(files, (file) => _.pick(file, 'name', 'url_path'));
                const dataKey = 'files';
                const oldFiles = this.data.get(dataKey);
                files = _.concat(oldFiles, files);
                this.data.splice(dataKey, [0, oldFiles.length, ...files]);
                this.updateDocumentFiles();
            },
        });
    }

    // 上传附件
    uploadFile() {
        const uploadEle = $(`#fileUploader input[type='file']`);
        uploadEle.click();
    }

    deleteFile(file: IHelpFile) {
        const dataKey = 'files';
        const files = this.data.get(dataKey);
        const index = _.findIndex(files, { url_path: file.url_path });
        this.data.removeAt(dataKey, index);
        this.updateDocumentFiles();
    }

    getDownloadFileHref(file: IHelpFile): string {
        return `${file.url_path}?downloadName=${encodeURIComponent(file.name)}`;
    }

    updateDocumentFiles() {
        const files = this.data.get('files');
        helpService.updateDocumentFiles(files).then(() => {
            toasterService.show({ type: 'success', title: '更新成功' });
        });
    }
}
